import { TemplateRef } from '@angular/core';

export interface RRIConfirmDeleteModalSettings<T> {
  modalTitle: string;
  modalTemplate: TemplateRef<any>;
  formatEntry(row: T): string;
}
